import { QueryFunction } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { API } from './api';

// Define a default query function that will receive the query key
const defaultQueryFn: QueryFunction = async ({ queryKey }): Promise<AxiosResponse['data']> => {
  return API().get({ path: queryKey[0] as string });
};

export const clientConfig = {
  defaultOptions: {
    queries: {
      gcTime: 0,
      queryFn: defaultQueryFn,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
};
